import React, {ReactNode} from "react";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import FaIcon from "@/components/utilities/fa-icon";

export default function AboutItem({
                                      title,
                                      description,
                                      faIcon,
                                      even,
                                  }: {
    title: string,
    description: string | ReactNode,
    faIcon: string,
    even?: boolean
}) {
    const theme = useTheme()

    return (
        <Box
            display="flex"
            alignItems="center"
            flexDirection={{xs: 'column', md: even ? "row-reverse" : "row"}}
            mb={10}
        >
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                borderRadius="50%"
                p={1}
                mb={2}
                width={66}
                height={66}
                bgcolor={theme.palette.grey[200]}
            >
                <FaIcon faIcon = {faIcon} fontSize = {36} color = {theme.palette.primary.main} />
            </Box >

            <Box
                display="flex"
                flexDirection="column"
                maxWidth={600}
                ml = {{xs: 0, md: even ? "0" :title.includes("اهداف") ? 5: 3}}
                mr = {{xs: 0, md: !even ? "0" : 3}}
            >
                <Typography
                    textAlign = {{xs: 'center', md: even ? "right" : "left"}}
                    mb = {1}
                    fontSize = {18}
                    fontWeight = {500}
                >
                    {title}
                </Typography >

                <Typography component = 'span' fontSize = {16} color="text.secondary" textAlign="justify">
                    {description}
                </Typography >

            </Box >
        </Box >
    );
};
